import { gql, useQuery } from "@apollo/client";
import { useEffect, useState, useCallback, useMemo, useContext } from "react";

// Components
import { Card, Grid } from "@mui/material";
import Footer from "components/Footer";
import DashboardLayout from "components/LayoutContainers/DashboardLayout";
import DashboardNavbar from "components/Navbars/DashboardNavbar";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import DataTable from "components/Tables/DataTable";
import CustomPagination from "components/Pagination";
import Loading from "components/Carteles/Loading";
import SinDatos from "components/Carteles/SinDatos";

import dataEmpresa from "./data/dataEmpresa";
import ModalActividades from "./components/ModalActividades/ModalActividades";
import { UserContext } from "context/user";

function MisEmpresas() {
  const [rows, setRows] = useState([]);

  const [page, setPage] = useState(1);
  const [pagesInfo, setPagesInfo] = useState({ pages: 0, total: 0 });
  const [orderBy, setOrderBy] = useState({ campo: "razonSocial", orden: "ASC" });
  const { columns, getRows } = dataEmpresa;
  const { user } = useContext(UserContext);

  const [selectedEmpresa, setSelectedEmpresa] = useState(null);
  const [modalActividades, setModalActividades] = useState(false);

  // Funciones con useCallback
  const handleOrderBy = useCallback((campo) => {
    setOrderBy((prev) => ({
      campo,
      orden: prev.campo === campo && prev.orden === "ASC" ? "DESC" : "ASC",
    }));
  }, []);

  const handleOpenMenu = useCallback((event, item) => {
    setSelectedEmpresa(item);
    setModalActividades(true);
  }, []);

  const { loading, error, data, refetch } = useQuery(
    gql`
      query getEmpresas($search: String, $page: Int, $order: Order) {
        paginationInfo {
          pages
          total
        }
        empresas(search: $search, pagination: { page: $page, limit: 10 }, order: $order) {
          id
          razonSocial
          cuit
          email
          gerente
          actividad
          estado
          responsableTecnico {
            id
            nombre
            apellido
            email
            matricula
          }
        }
      }
    `,
    {
      variables: {
        search: null,
        page: page,
        order: { field: orderBy.campo, order: orderBy.orden },
        // filter: {
        //   idResponsable: null,
        // }
      },
      fetchPolicy: "no-cache",
    }
  );

  // useMemo para recalcular las filas solo cuando data o la función getRows cambien
  const memoizedRows = useMemo(() => {
    if (data) {
      return getRows(data.empresas, handleOpenMenu);
    }
    return [];
  }, [data, getRows, handleOpenMenu]);

  useEffect(() => {
    if (data) {
      setRows(memoizedRows);
      setPagesInfo(data.paginationInfo);
    }
  }, [data, memoizedRows]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox py={3}>
        <SoftBox>
          <Card>
            <Grid container spacing={2} p={3}>
              <Grid item xs={12}>
                <SoftBox display="flex" justifyContent="space-between" alignItems="center">
                  <SoftTypography variant="h6" fontWeight="bold">
                    Empresas asignadas a mi usuario
                  </SoftTypography>
                  {/* <SoftBox display="flex" alignItems="center" gap={2}>
                    <SoftInput
                      placeholder="Buscar..."
                      icon={{ component: "search", direction: "left" }}
                      onChange={handleSearch}
                      value={searchInput}
                    />
                    
                  </SoftBox> */}
                </SoftBox>
              </Grid>
            </Grid>
            <SoftBox>
              {loading ? (
                <Loading />
              ) : rows?.length > 0 ? (
                <DataTable columns={columns} rows={rows} order={orderBy} setOrder={handleOrderBy} />
              ) : (
                <SinDatos />
              )}
            </SoftBox>
            <CustomPagination
              loading={loading}
              length={rows.length}
              total={pagesInfo.total}
              pages={pagesInfo.pages}
              page={page}
              setPage={setPage}
              noCard
            />
          </Card>
        </SoftBox>
        <ModalActividades
          selectedEmpresa={selectedEmpresa}
          open={modalActividades}
          handleClose={() => setModalActividades(false)}
          idUser={user?.responsable?.id}
        />
      </SoftBox>
      <Footer />
    </DashboardLayout>
  );
}

export default MisEmpresas;
